
export default {
  seo: {
    title: 'الدورات التدريبية - معهد كونفوشيوس SAI الأكاديمي',
    description: 'استكشف دوراتنا الشاملة في اللغة الصينية من المستوى المبتدئ إلى المتقدم. دورات HSK، الصينية للأعمال، والمزيد مع مدرسين خبراء وشهادات معتمدة.',
    keywords: 'دورات اللغة الصينية، HSK، معهد كونفوشيوس، تعلم الصينية، دورات أونلاين، شهادة HSK، الصينية للأعمال'
  },
  breadcrumb: {
    home: 'الرئيسية',
    courses: 'الدورات التدريبية'
  },
  hero: {
    title: 'دوراتنا التدريبية',
    subtitle: 'اكتشف مجموعة واسعة من دورات اللغة الصينية المصممة لجميع المستويات',
    coursesCount: 'دورة تدريبية',
    expertInstructors: 'مدرسون خبراء',
    certification: 'شهادات معتمدة'
  },
  stats: {
    totalCourses: 'دورة تدريبية',
    totalStudents: 'طالب مسجل',
    averageRating: 'متوسط التقييم',
    yearsExperience: 'سنة خبرة',
    certifiedInstructors: 'مدرس معتمد'
  },
  filters: {
    searchPlaceholder: 'ابحث عن دورة...',
    level: 'المستوى',
    category: 'الفئة',
    mode: 'نمط الدراسة',
    allLevels: 'جميع المستويات',
    allCategories: 'جميع الفئات',
    allModes: 'جميع الأنماط',
    resultsFound: 'نتيجة',
    clearAll: 'مسح الكل',
    gridView: 'عرض شبكي',
    listView: 'عرض قائمة',
    priceRanges: {
      all: 'جميع الأسعار',
      free: 'مجاني',
      under500: 'أقل من $500',
      '500to1000': '$500 - $1000',
      over1000: 'أكثر من $1000'
    },
    ratings: {
      all: 'جميع التقييمات',
      '4plus': '4+ نجوم',
      '4.5plus': '4.5+ نجوم'
    },
    durations: {
      all: 'جميع المدد',
      short: 'قصيرة (≤8 أسابيع)',
      medium: 'متوسطة (9-16 أسبوع)',
      long: 'طويلة (17+ أسبوع)'
    },
    sortBy: {
      popularity: 'الأكثر شعبية',
      rating: 'الأعلى تقييماً',
      priceLowToHigh: 'السعر: من الأقل للأعلى',
      priceHighToLow: 'السعر: من الأعلى للأقل',
      newest: 'الأحدث'
    }
  },
  levels: {
    beginner: 'مبتدئ',
    elementary: 'ابتدائي',
    intermediate: 'متوسط',
    advanced: 'متقدم',
    professional: 'احترافي'
  },
  categories: {
    hsk: 'HSK',
    business: 'الأعمال',
    yct: 'YCT',
    conversation: 'المحادثة',
    culture: 'الثقافة'
  },
  modes: {
    online: 'أونلاين',
    offline: 'حضوري',
    hybrid: 'هجين'
  },
  meta: {
    weeks: 'أسبوع',
    hours: 'ساعة',
    perSemester: 'للفصل الدراسي',
    duration: 'المدة',
    level: 'المستوى',
    mode: 'نمط الدراسة',
    language: 'لغة التدريس',
    certificate: 'الشهادة'
  },
  cta: {
    viewCourse: 'عرض الدورة',
    contactUs: 'تواصل معنا',
    whatsapp: 'واتساب',
    title: 'هل أنت مستعد لبدء رحلتك؟',
    subtitle: 'انضم إلى آلاف الطلاب الذين يتعلمون اللغة الصينية معنا'
  },
  noResults: {
    title: 'لم يتم العثور على نتائج',
    message: 'حاول تغيير معايير البحث أو الفلاتر'
  },

  // Comparison Feature
  comparison: {
    compare: 'مقارنة',
    addToCompare: 'إضافة للمقارنة',
    removeFromCompare: 'إزالة من المقارنة',
    compareCourses: 'مقارنة الدورات',
    compareNow: 'قارن الآن',
    selected: 'المحددة',
    clearAll: 'مسح الكل',
    title: 'مقارنة الدورات',
    subtitle: 'قارن بين الدورات المختلفة لاختيار الأنسب لك',
    feature: 'الميزة',
    image: 'الصورة',
    courseName: 'اسم الدورة',
    price: 'السعر',
    duration: 'المدة',
    level: 'المستوى',
    rating: 'التقييم',
    students: 'عدد الطلاب',
    studyMode: 'نمط الدراسة',
    certification: 'الشهادة',
    instructor: 'المدرس',
    modules: 'عدد الوحدات',
    startDate: 'تاريخ البدء',
    location: 'الموقع',
    action: 'الإجراء',
    viewCourse: 'عرض الدورة',
    remove: 'إزالة',
    close: 'إغلاق',
    bestPrice: 'أفضل سعر',
    highestRated: 'الأعلى تقييماً',
    maxCoursesReached: 'يمكنك مقارنة 3 دورات كحد أقصى',
    selectCoursesToCompare: 'اختر دورتين على الأقل للمقارنة'
  },

  // Course Detail Page
  courseOverview: 'نظرة عامة على الدورة',
  learningOutcomes: 'نتائج التعلم',
  courseBenefits: 'مميزات الدورة',
  courseCurriculum: 'المنهج الدراسي',
  curriculumDescription: 'منهج شامل ومنظم يغطي جميع جوانب اللغة الصينية',
  lessons: 'دروس',
  targetAudience: 'الفئة المستهدفة',
  targetAudienceDescription: 'هذه الدورة مصممة خصيصاً لـ',
  certification: 'الشهادة',
  certificationNote: 'ستحصل على شهادة معتمدة عند إتمام الدورة بنجاح',
  courseInstructor: 'المدرس',
  credentials: 'المؤهلات',
  biography: 'السيرة الذاتية',
  yearsExp: 'سنوات خبرة',
  faq: 'الأسئلة الشائعة',
  faqDescription: 'إجابات على الأسئلة الأكثر شيوعاً حول الدورة',
  stillHaveQuestions: 'لا تزال لديك أسئلة؟',
  contactUsForMore: 'تواصل معنا للحصول على مزيد من المعلومات',
  relatedCourses: 'دورات ذات صلة',
  relatedCoursesDescription: 'دورات أخرى قد تهمك',
  viewAllCourses: 'عرض جميع الدورات',

  // Course Details Sidebar
  courseDetails: 'تفاصيل الدورة',
  coursePrice: 'سعر الدورة',
  specialOffer: 'عرض خاص',
  startDate: 'تاريخ البدء',
  location: 'الموقع',
  instructor: 'المدرس',
  moneyBackGuarantee: 'ضمان استرداد الأموال',
  limitedSeats: 'مقاعد محدودة',
  needHelp: 'تحتاج مساعدة؟',
  whatsappUs: 'تواصل عبر واتساب',
  callUs: 'اتصل بنا',

  // Actions
  enrollNow: 'سجل الآن',
  downloadBrochure: 'تحميل الكتيب',
  brochureDownloading: 'جاري تحميل الكتيب...',
  loading: 'جاري التحميل...',

  // Common
  home: 'الرئيسية',
  courses: 'الدورات',
  contactUs: 'تواصل معنا',
  chineseLearning: 'تعلم اللغة الصينية',
  siteTitle: 'كلية صاعد الأكاديمية',
  students: 'طالب',

  // Course Badges
  badges: {
    hsk: 'HSK',
    diploma: 'دبلوم',
    scholarship: 'منحة دراسية',
    certified: 'معتمد',
    online: 'أونلاين',
    offline: 'حضوري',
    hybrid: 'هجين'
  },

  // Module/Lesson Terms
  module: 'وحدة',
  lesson: 'درس',
  modules: 'وحدات',

  // Time Units
  weeks: 'أسابيع',
  months: 'أشهر',
  hours: 'ساعات',

  // Course Info Labels
  enrolled: 'مسجل',
  rating: 'التقييم',
  reviews: 'تقييم',

  // SEO Templates for Individual Courses
  courseSeoTitle: '{courseName} - كلية صاعد الأكاديمية | معهد كونفوشيوس',
  courseSeoDescription: 'تعلم {courseName} مع مدرسين خبراء في كلية صاعد الأكاديمية. دورة شاملة تغطي {level} مع شهادة معتمدة. سجل الآن!',
  courseSeoKeywords: '{courseName}, تعلم الصينية, HSK, معهد كونفوشيوس, دورات اللغة الصينية, كلية صاعد, صنعاء, اليمن',

  // Enrollment Form
  enrollment: {
    title: 'التسجيل في الدورة',
    courseLabel: 'الدورة المختارة',
    fullName: 'الاسم الكامل',
    fullNamePlaceholder: 'أدخل اسمك الكامل',
    email: 'البريد الإلكتروني',
    emailPlaceholder: 'example@email.com',
    phone: 'رقم الهاتف',
    phonePlaceholder: '+967 777 123 456',
    studyMode: 'نمط الدراسة المفضل',
    studyModePlaceholder: 'اختر نمط الدراسة',
    studyModes: {
      online: 'أونلاين',
      offline: 'حضوري',
      hybrid: 'هجين (أونلاين + حضوري)',
    },
    preferredStartDate: 'تاريخ البدء المفضل',
    chineseLevel: 'مستوى اللغة الصينية الحالي',
    chineseLevelPlaceholder: 'اختر مستواك الحالي',
    levels: {
      none: 'لا توجد خبرة سابقة',
      beginner: 'مبتدئ (بعض الكلمات)',
      hsk1: 'HSK 1',
      hsk2: 'HSK 2',
      hsk3: 'HSK 3',
      hsk4: 'HSK 4',
      hsk5: 'HSK 5',
      hsk6: 'HSK 6',
    },
    message: 'ملاحظات إضافية',
    messagePlaceholder: 'أي معلومات إضافية تود مشاركتها معنا...',
    privacyNote: 'معلوماتك محمية ولن تُشارك مع أي طرف ثالث. سيتواصل معك فريقنا خلال 24 ساعة.',
    submit: 'إرسال طلب التسجيل',
    submitting: 'جاري الإرسال...',
    cancel: 'إلغاء',
    close: 'إغلاق',
    successTitle: 'تم إرسال طلبك بنجاح! 🎉',
    successMessage: 'شكراً لاهتمامك بالتسجيل في الدورة. سيتواصل معك فريقنا خلال 24 ساعة لتأكيد تسجيلك وإرشادك للخطوات التالية.',
    errors: {
      fullNameRequired: 'الاسم الكامل مطلوب',
      emailRequired: 'البريد الإلكتروني مطلوب',
      emailInvalid: 'صيغة البريد الإلكتروني غير صحيحة',
      phoneRequired: 'رقم الهاتف مطلوب',
      phoneInvalid: 'صيغة رقم الهاتف غير صحيحة',
      studyModeRequired: 'يرجى اختيار نمط الدراسة',
      startDateRequired: 'يرجى اختيار تاريخ البدء',
      chineseLevelRequired: 'يرجى اختيار مستواك الحالي',
    },
  },
};

export const courses = {
  // Course Detail Page
  courseOverview: 'نظرة عامة على الدورة',
  learningOutcomes: 'نتائج التعلم',
  courseBenefits: 'مميزات الدورة',
  courseCurriculum: 'المنهج الدراسي',
  curriculumDescription: 'منهج شامل ومنظم يغطي جميع جوانب اللغة الصينية',
  lessons: 'دروس',
  targetAudience: 'الفئة المستهدفة',
  targetAudienceDescription: 'هذه الدورة مصممة خصيصاً لـ',
  certification: 'الشهادة',
  certificationNote: 'ستحصل على شهادة معتمدة عند إتمام الدورة بنجاح',
  courseInstructor: 'المدرس',
  credentials: 'المؤهلات',
  biography: 'السيرة الذاتية',
  yearsExp: 'سنوات خبرة',
  faq: 'الأسئلة الشائعة',
  faqDescription: 'إجابات على الأسئلة الأكثر شيوعاً حول الدورة',
  stillHaveQuestions: 'لا تزال لديك أسئلة؟',
  contactUsForMore: 'تواصل معنا للحصول على مزيد من المعلومات',
  relatedCourses: 'دورات ذات صلة',
  relatedCoursesDescription: 'دورات أخرى قد تهمك',
  viewAllCourses: 'عرض جميع الدورات',

  // Course Details Sidebar
  coursePrice: 'سعر الدورة',
  specialOffer: 'عرض خاص',
  startDate: 'تاريخ البدء',
  location: 'الموقع',
  instructor: 'المدرس',
  moneyBackGuarantee: 'ضمان استرداد الأموال',
  limitedSeats: 'مقاعد محدودة',
  needHelp: 'تحتاج مساعدة؟',
  whatsappUs: 'تواصل عبر واتساب',
  callUs: 'اتصل بنا',

  // Actions
  enrollNow: 'سجل الآن',
  downloadBrochure: 'تحميل الكتيب',
  brochureDownloading: 'جاري تحميل الكتيب...',
  loading: 'جاري التحميل...',

  // Common
  home: 'الرئيسية',
  courses: 'الدورات',
  contactUs: 'تواصل معنا',
  chineseLearning: 'تعلم اللغة الصينية',
  siteTitle: 'كلية صاعد الأكاديمية',

  // YCT Program Page
  yct: {
    hero: {
      title: 'برنامج اختبار اللغة الصينية للأطفال (YCT)',
      subtitle: 'رحلة ممتعة لتعلم اللغة الصينية للأطفال والمراهقين',
      description: 'اختبار اللغة الصينية للشباب (YCT) هو اختبار دولي موحد للكفاءة في اللغة الصينية مصمم خصيصاً للطلاب الصغار من سن 6 إلى 15 عاماً.',
      enrollButton: 'سجل طفلك الآن',
      learnMoreButton: 'اعرف المزيد'
    },
    whatIsYCT: {
      title: 'ما هو اختبار YCT؟',
      description: 'اختبار اللغة الصينية للشباب (YCT) هو اختبار دولي موحد للكفاءة في اللغة الصينية. يقيم قدرة الطلاب الصغار على استخدام اللغة الصينية في حياتهم اليومية والأكاديمية.',
      levels: {
        title: 'مستويات YCT',
        level1: {
          name: 'YCT المستوى 1',
          description: '80 كلمة - مثالي للمبتدئين الذين بدأوا للتو رحلة تعلم اللغة الصينية',
          vocabulary: '80 كلمة'
        },
        level2: {
          name: 'YCT المستوى 2',
          description: '150 كلمة - بناء أساس قوي مع المفردات والعبارات الأساسية',
          vocabulary: '150 كلمة'
        },
        level3: {
          name: 'YCT المستوى 3',
          description: '300 كلمة - توسيع المهارات اللغوية للمحادثات اليومية',
          vocabulary: '300 كلمة'
        },
        level4: {
          name: 'YCT المستوى 4',
          description: '600 كلمة - إتقان اللغة الصينية للتواصل الواثق',
          vocabulary: '600 كلمة'
        }
      }
    },
    benefits: {
      title: 'لماذا تختار برنامج YCT؟',
      benefit1: {
        title: 'تعلم ممتع وتفاعلي',
        description: 'دروس جذابة مع الألعاب والأنشطة والوسائط المتعددة المصممة للمتعلمين الصغار'
      },
      benefit2: {
        title: 'شهادة معترف بها دولياً',
        description: 'احصل على شهادة YCT الرسمية المعترف بها في جميع أنحاء العالم'
      },
      benefit3: {
        title: 'مناسب للعمر',
        description: 'منهج مصمم خصيصاً لمراحل التطور المعرفي للأطفال'
      },
      benefit4: {
        title: 'مدرسون خبراء',
        description: 'معلمون ذوو خبرة متخصصون في تعليم اللغة الصينية للأطفال'
      },
      benefit5: {
        title: 'فصول صغيرة',
        description: 'اهتمام شخصي مع أحجام فصول صغيرة لتحقيق أفضل النتائج'
      },
      benefit6: {
        title: 'جداول مرنة',
        description: 'خيارات دراسة عبر الإنترنت وحضورية تناسب جدول عائلتك'
      }
    },
    ageGroups: {
      title: 'الفئات العمرية المستهدفة',
      group1: {
        age: '6-12 سنة',
        title: 'الأطفال الصغار',
        description: 'مثالي للأطفال في المرحلة الابتدائية الذين يبدأون رحلة تعلم اللغة الصينية',
        levels: 'YCT المستوى 1-3'
      },
      group2: {
        age: '13-15 سنة',
        title: 'المراهقون الصغار',
        description: 'مصمم لطلاب المرحلة المتوسطة الذين يرغبون في تعميق مهاراتهم في اللغة الصينية',
        levels: 'YCT المستوى 3-4'
      }
    },
    curriculum: {
      title: 'نظرة عامة على المنهج',
      description: 'يتبع برنامج YCT الخاص بنا منهجاً منظماً يبني المهارات اللغوية تدريجياً',
      level1: {
        title: 'YCT المستوى 1',
        topics: [
          'التحيات والتعريفات الأساسية',
          'الأرقام والألوان',
          'أفراد العائلة',
          'الحيوانات والطعام الشائع',
          'الأنشطة اليومية البسيطة'
        ]
      },
      level2: {
        title: 'YCT المستوى 2',
        topics: [
          'الوقت والتاريخ',
          'الطقس والفصول',
          'الهوايات والاهتمامات',
          'الحياة المدرسية',
          'التسوق والأسعار'
        ]
      },
      level3: {
        title: 'YCT المستوى 3',
        topics: [
          'وصف الأشخاص والأماكن',
          'التعبير عن التفضيلات',
          'الحديث عن الخبرات السابقة',
          'تقديم الاقتراحات',
          'فهم النصوص البسيطة'
        ]
      },
      level4: {
        title: 'YCT المستوى 4',
        topics: [
          'المحادثات المعقدة',
          'التعبير عن الآراء',
          'فهم الثقافة الصينية',
          'القراءة والكتابة المتقدمة',
          'الاستعداد لاختبار HSK'
        ]
      }
    },
    instructor: {
      title: 'تعرف على مدرسك',
      name: 'لي شياومي',
      role: 'مدرس YCT الرئيسي',
      bio: 'مع أكثر من 10 سنوات من الخبرة في تعليم اللغة الصينية للأطفال، تتخصص المعلمة لي في جعل تعلم اللغة ممتعاً وجذاباً. حاصلة على شهادة في تعليم اللغة الصينية كلغة أجنبية وشغوفة بمساعدة الطلاب الصغار على اكتشاف جمال اللغة والثقافة الصينية.',
      qualifications: [
        'ماجستير في تعليم اللغة الصينية كلغة أجنبية',
        'شهادة تدريس YCT',
        '10+ سنوات من الخبرة في التدريس',
        'متخصصة في تعليم الأطفال'
      ]
    },
    testimonials: {
      title: 'ماذا يقول الآباء',
      testimonial1: {
        text: 'ابنتي تحب دروس YCT! المعلمة لي تجعل التعلم ممتعاً جداً، وقد تحسنت لغتها الصينية بشكل كبير في بضعة أشهر فقط.',
        parent: 'سارة أحمد',
        relation: 'والدة طالبة YCT المستوى 2'
      },
      testimonial2: {
        text: 'برنامج رائع للأطفال! المنهج مصمم بشكل جيد، والمعلمون صبورون ومحترفون. ابني متحمس لكل درس.',
        parent: 'محمد علي',
        relation: 'والد طالب YCT المستوى 3'
      },
      testimonial3: {
        text: 'أفضل استثمار في تعليم ابنتي. اجتازت اختبار YCT المستوى 1 بدرجات ممتازة وهي الآن واثقة من التحدث بالصينية.',
        parent: 'فاطمة حسن',
        relation: 'والدة طالبة YCT المستوى 1'
      }
    },
    faq: {
      title: 'الأسئلة الشائعة',
      question1: {
        q: 'ما هو العمر المناسب لبدء برنامج YCT؟',
        a: 'برنامج YCT مصمم للأطفال من سن 6 إلى 15 عاماً. نوصي ببدء YCT المستوى 1 للأطفال من سن 6-8 سنوات دون خبرة سابقة في اللغة الصينية.'
      },
      question2: {
        q: 'كم مرة تُعقد الدروس؟',
        a: 'نقدم خيارات جدولة مرنة. عادةً، نوصي بدرسين إلى ثلاثة دروس في الأسبوع، كل درس مدته 60 دقيقة، لتحقيق أفضل النتائج.'
      },
      question3: {
        q: 'هل يحتاج طفلي إلى أي خبرة سابقة؟',
        a: 'لا، YCT المستوى 1 مصمم للمبتدئين الكاملين. سيبدأ طفلك من الأساسيات ويتقدم تدريجياً.'
      },
      question4: {
        q: 'ما هي المواد المطلوبة؟',
        a: 'سنوفر جميع المواد الدراسية بما في ذلك الكتب المدرسية وأوراق العمل والموارد عبر الإنترنت. ستحتاج فقط إلى دفتر ملاحظات وأقلام للواجبات المنزلية.'
      },
      question5: {
        q: 'متى يمكن لطفلي إجراء اختبار YCT؟',
        a: 'تُعقد اختبارات YCT الرسمية عدة مرات في السنة. سنوصي بموعد الاختبار عندما يكون طفلك جاهزاً بناءً على تقدمه.'
      },
      question6: {
        q: 'هل تقدمون دروساً عبر الإنترنت؟',
        a: 'نعم! نقدم كلاً من الدروس الحضورية والدروس عبر الإنترنت. دروسنا عبر الإنترنت تفاعلية وجذابة تماماً مثل الدروس الحضورية.'
      }
    },
    cta: {
      title: 'هل أنت مستعد لبدء رحلة طفلك في تعلم اللغة الصينية؟',
      description: 'انضم إلى برنامج YCT اليوم وامنح طفلك هدية إتقان اللغة والوعي الثقافي',
      enrollButton: 'سجل الآن',
      contactButton: 'اتصل بنا'
    }
  }
};

/* 
  Note: The original file had two default exports, which caused a runtime error.
  We kept the primary translation object as the default export and retained the
  `courses` object as a named export. This resolves the "Multiple exports with the
  same name 'default'" issue while preserving all existing functionality.
*/
